import type { HelpTranslations } from "../../types/help";

export const help: HelpTranslations = {
  introParagraph:
    "Welcome to Franklin's help page. Here you can find answers to frequently asked questions.",
  faqs: [
    {
      question: "How do I create a new building?",
      answer: "On “My Buildings”, click “Add New Building”, fill in the form and confirm.",
    },
    {
      question: "How do I edit building details?",
      answer:
        "On the building dashboard, click the registry code, net area or floors under the title to change it. Everything else about the building is on the “Building Data” page, where you can review, confirm and correct each value.",
    },
    {
      question: "What is a project brief?",
      answer:
        "The project brief collects the client's requirements: the files in the project's Brief folder plus written additions. Franklin can help you check it against the project's documents and point out possible gaps or conflicts, but the review stays yours.",
    },
  ],
  faqsTitle: "FAQs",
  tosTitle: "Terms of Service",
};
